<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.find-ean.code_ean')}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <template v-if="selected">
                    <div class="font-bold">{{selected.modele}}</div>
                    <div class="text-sm font-light">{{selected.ean}}</div>
                </template>
            </template>

            <template v-slot:open>
                <input
                type="text"
                class="mb-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                :placeholder="$t('form.find-ean.rechercher_un_article')"
                v-model="ean"
                @input="findEan"
                >
                <sav-spinner class="mb-3" v-if="loading" :size="10" />
                <template v-if="data">
                    <div
                    v-for="item in data"
                    :key="item.id"
                    class="relative flex flex-col min-w-0 mb-3 break-words duration-200 bg-white border border-gray-300 rounded cursor-pointer border-1 hover:border-gray-350 hover:bg-gray-50 hover:shadow my-rounded"
                    @click="end(item)"
                    >
                        <div class="p-6">
                            <div class="font-bold">{{item.modele}}</div>
                            <div class="text-sm font-light">{{item.ean}}</div>
                        </div>
                    </div>
                    <div
                    class="relative flex flex-col min-w-0 px-5 py-4 mb-3 font-light text-gray-400 break-words bg-white border border-gray-300 rounded border-1 my-rounded"
                    v-if="data && data.length <= 0"
                    >
                        {{$t('form.find-ean.aucun_resultat')}}
                    </div>
                </template>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'find-ean-product',
    extends: FormCardExtension,

    data() {
        return {
            ean: null,
            timerSearch: null
        }
    },

    methods: {
        async init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.nextBlock = await this.getNextBlock()
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.loading = false
        },

        async end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.$formTool.addFormData('device', [
                    {
                        value: {
                            id: callbackData.id,
                            Modele: callbackData.modele
                        }
                    }
            ])
            this.nextBlock = await this.getNextBlock()
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        findEan() {
            this.loading = true
            // Get api data
            if (this.ean.length < 2) {
                this.data = null
                this.loading = false
                return
            }
            window.clearTimeout(this.timerSearch)
            this.timerSearch = setTimeout(async () => {
                this.data = null
                let response = await apiService.post('getean', {
                    ean: this.ean
                })
                this.data = response.data.posts.post
            }, 500)
            this.loading = false
        },

        async getBdc() {
            let responseBdc = await apiService.post('getbdc', {
                id_app: this.$formTool.getFormData(this.$options.name).id_app
            })
            return responseBdc.data.posts
        },
        async getBdc2() {
            let responseBdc = await apiService.post('getbdc2', {
                id_app: this.$formTool.getFormData(this.$options.name).id_app
            })
            return responseBdc.data.posts
        },

        async getNextBlock() { 
            // Waiting request
            if (!this.$formTool.getFormData('find-ticket').found) {
                return this.$formTool.blockData(this.$options.name).next.wait
            }

            // Check code_panne
            let responseCodePanne = await apiService.post('getcodesymptome', {
                id_app: this.$formTool.getFormData('device')[0].value.id
            })
            if (responseCodePanne.data.posts.code_symptome && responseCodePanne.data.posts.code_symptome.length > 0) {
                this.$formTool.addFormData('code_symptome', responseCodePanne.data.posts.code_symptome)
                return this.$formTool.blockData(this.$options.name).next.code_panne
            }

            let responseBdc = await this.getBdc()
            this.$formTool.addFormData('bdc', responseBdc)
            if (responseBdc.spareka) {
                return this.$formTool.blockData(this.$options.name).next.spareka
            } else if (responseBdc.post && responseBdc.post.length > 0) {
                let responseBdc2 = await this.getBdc2()
                this.$formTool.addFormData('bdc2', responseBdc2)
                if (this.$companyTool.confFile().chatbot == '1') {
                    return this.$formTool.blockData(this.$options.name).next.newOwnTchat
                } else {
                    return this.$formTool.blockData(this.$options.name).next.ownTchat
                }
            }
            return this.$formTool.blockData(this.$options.name).next.continue
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/shop/FindEanProductCard.vue